import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ThemeService } from 'ng2-charts';

@Injectable()
export class EndpointsService {

  URL_UPDATE_USER : string;
  URL_CREATE_USER : string;
  URL_INSERT_ROLE : string;
  URL_DELETE_ROLE : string;
  URL_DELETE_USER : string;
  URL_UPDATE : string;
  API_BASE_URL: string;
  URL_GET_ALL_USERS:string;
  URL_GET_SIM_CARD_DATA: string;
  URL_GET_CREDIT_DATA: string;
  URL_GET_COUNTRY_LIST: string;
  URL_GET_TAP_CODE_LIST: string;
  URL_GET_OPERATOR_LIST: string;
  URL_GET_OPERATOR_LIST_BY_COUNTRY: string;
  URL_INSERT_SIM_CARD_DATA: string;
  URL_UPDATE_SIM_CARD_DATA: string;
  URL_DELETE_SIM_CARD_DATA: string;
  URL_SEND_MAIL: string;
  URL_GET_CREDIT_INFO: string;
  URL_GET_CREDIT_USAGE_INFO: string;
  URL_GET_AFFILIATE_LIST_ORDER: string;
  URL_INSERT_ORDER: string;
  URL_UPDATE_ORDER: string;
  URL_DELETE_ORDER: string;
  URL_GET_ORDER: string;
  URL_INSERT_ORDER_REMINDER: string;
  URL_UPDATE_ORDER_REMINDER: string;
  URL_GET_ORDER_REMINDER: string;
  URL_DELETE_ORDER_REMINDER: string;
  URL_GET_AUDIT: string;
  URL_INSERT_AUDIT: string;
  URL_GET_IR21DATA: string;
  URL_GET_IR21DATA_OPENFILE: string;
  URL_GET_DELETE_IR21_FILE: string;
  URL_INSERT_FILE: string;
  URL_GET_NETWORK_CENTER: string;
  URL_GET_NETWORK_CENTER_API: string;
  URL_UPLOAD_CORE_FILE: string;
  URL_AUDIT_COMPARISON: string;
  URL_GET_AUDIT_NAME: string;
  URL_GET_TAP_CODE_MULTI: string;
  URL_UPDATE_AUDIT: string;
  URL_INSERT_REMINDER_AUDIT: string;
  URL_GET_AUDIT_REMINDER: string;
  URL_NETWORK_CENTER_EMAIL: string;
  URL_GET_NODE_INFO: string;
  URL_APP_LOGIN: string;
  URL_APP_RESET_PASSWORD: string;
  URL_INSERT_SERVICE_OPEN: string;
  URL_UPDATE_SERVICE_OPEN: string;
  URL_GET_SERVICE_OPEN: string;
  URL_INSERT_SERVICE_OPEN_EMAIL: string;
  URL_GET_SERVICE_EMAIL_HISTORY: string;
  URL_SERVICE_OPEN_INSERT_REMINDER: string;
  URL_SERVICE_OPEN_GET_REMINDER: string;
  URL_GET_SERVICES: string;
  URL_GET_SERVICE_OPENING: string;
  URL_ADD_SERVICE_COMMENT: string;
  URL_VIEW_SERVICE_COMMENT: string;
  URL_SERVICE_OPEN_UPLOAD: string;
  URL_SERVICE_OPEN_GET_CONTACTS: string;
  URL_SERVICE_OPEN_GET_DOCUMENTS: string;
  URL_GET_SERVICE_MONITOR: string;
  URL_GET_SERVICE_MONITOR_SECOND: string;
  URL_GET_SERVICE_TRACKER: string;
  URL_GET_SERVICE_TRACKER_GRAPH: string;
  URL_GET_HEAT_MAP_ONE: string;
  URL_GET_HEAT_MAP_TWO: string;
  URL_GET_HEAT_MAP_ONE_REPORT_ONE: string;
  URL_GET_HEAT_MAP_ONE_REPORT_TWO: string;
  URL_GET_HEAT_MAP_TWO_REPORT_ONE: string;
  URL_GET_HEAT_MAP_TWO_REPORT_TWO: string;
  URL_EMAIL_WITH_ATTACHMENT: string;
  URL_GET_AUDIT_SUMMARY: string;
  URL_GET_AUDIT_MATCH_DETAILS: string;
  URL_GET_EMAIL_LIST: string;
  URL_GET_REGION_LIST: string;
  URl_GET_DEAL_ID: string;
  URL_GET_COUNTRY_BY_REGION: string;
  URL_GET_TAGID_BY_COUNTRY: string;
  URl_GET_DEAL_RELATION: string;
  URL_GET_DEAL_TABLE_DATA: string;
  URL_SAVE_DEAL_INFO: string;
  URL_GET_DEAL_INFO: string;
  URL_GET_OVERVIEW_DATA: string;
  URL_GET_LATEST_DEAL: string;
  URL_GET_DEAL_NOTIFICATION: string;
  URL_GET_DEAL_INFO_CONTACT: string;
  URL_GET_CONTACT_MANAGEMENT: string;
  URL_GET_CONTACT_DETAILS: string;
  URL_GET_DEAL_COVERAGE: string;
  URL_GET_DEAL_SUMMARY: string;
  URL_UPDATE_DEAL_STATUS: string;
  URL_SEND_DEAL_MAIL: string;
  URL_GET_MARKET_PERFORMANCE_INFO: string;
  URL_GET_MARKET_PERFORMANCE_OPERTOR_VPMN_NETWORK: string;
  URL_GET_MARKET_PERFORMANCE_OPERTOR_MEMBER_OF_DEAL_NETWORK: string;
  URL_GET_MARKET_PERFORMANCE_TRFFIC: string;
  URL_GET_MARKET_PERFORMANCE_IOT: string;
  URL_GET_DEAL_EVOLUTION: string;
  URL_GET_MARKET_TRACKER: string;
  URL_GET_DEAL_APPROVER: string;
  URL_GET_PERFORMANCE_CHART: string;
  URL_GET_METRICES_CHART: string;
  URL_GENERATE_EXCEL: string;
  URL_GET_PERFORMANCE_TABLE: string;
  URL_GET_METRIC_TABLE: string;
  URL_GET_INBOUND_PERFORMANCE_CHART: string;
  URL_GET_INBOUND_PERFORMANCE_TABLE: string;
  URL_GET_INBOUND_TRAFFIC_TABLE: string;
  URL_GET_DEAL_SUMMARY_DATA: string;
  URL_GET_MARKET_SIMULATOR: string;
  URL_GET_MARKET_PERFORMANCE_DEAL_GRAPH: string;
  URL_GET_ORDER_NAME: string;
  URL_BULK_SIM_UPLOAD: string;
  URL_GET_NETWORK_FILE_WO_SNO: string;
  URL_COMMITMENT_GRAPH_DATA: string;
  URL_MARKET_PERFORMANCE_DEAL_OF_MEMBERS: string;
  URL_MARKET_PERFORMANCE_CHARGES: string;
  URL_GET_COUNTRY_INDIVIDUAL: string;
  URl_GET_RETAIL: string;
  URL_GET_POSTPAID_PRODUCT: string;
  URL_ADD_PRODUCT: string;
  URL_UPDATE_PRODUCT: string;
  URL_DELETE_PRODUCT: string;
  URL_DELETE_POSTPAID: string;
  URL_ADD_CAMPAIGN: string;
  URL_GET_CAMPAIGN: string;
  URL_GET_CAMPAIGN_TABLE: string;
  URL_DELETE_CAMPAIGN: string;
  URL_EDIT_CAMPAIGN: string;
  URL_GET_ZONES: string;
  URL_GET_CONSUMER_CALL_MOC: string;
  URL_GET_CONSUMER_CALL_MTC_GPRS_MESSAGING: string;
  URL_UPDATE_CONSUMER_CALL_MTC_GPRS_MESSAGING: string;
  URL_INSERT_CONSUMER_CALL_MTC_GPRS_MESSAGING: string;
  URL_GET_COUNTRY_BY_ZONES: string;
  URL_GET_DOCUMENT_REPOSITORY: string;
  INSERT_DOCUMENT_REPOSITORY: string;
  ROAMERS_SEGMENT_DETAILS: string;
  ROAMERS_SEGMENT_COUNT_HISTORY: string;
  PRICE_POINT_HISTORY: string;
  ROAMERS_PACK_HISTORY: string;
  ROAMERS_ERROR_CODE_REPORT: string;
  STATISTICS_REPORT: string;
  MESSAGE_DELIVERY_STATIC:string;
  MESSAGE_COUNT_HISTORY:string; 
  REPITIVE_COUNT_HISTORY:string;
  COUNTRY_DETAILS:string;
  NETWORK_DETAILS:string;
  URL_GET_TARRIFF: string;
  INSERT_TARRIFF: string;
  URL_GET_WHITELIST: string;
  INSERT_WHITELIST: string;
  INSERT_BLACKLIST: string;
  URL_UPDATE_TARRIFF: string;
  URL_DELETE_TARRIFF: string;
  URL_UPDATE_WHITELIST: string;
  URL_DELETE_WHITELIST: string;
  URL_GET_BLACKLIST: string;
  URL_DELETE_BLACKLIST: string;
  URL_UPDATE_BLACKLIST: string;
  URL_GET_ECOWAS_BUSINESS_RULE: string;
  INSERT_ECOWAS_BUSINESS_RULE: string;
  URL_GET_COMMUNITY_NETWORK: string;
  URL_GET_COMMUNITY_COUNTRY: string;
  URL_GET_COMMUNITY: string;
  URL_INSERT_COMMUNITY: string;
  URL_DELETE_COMMUNITY: string;
  URL_UPDATE_COMMUNITY: string;
  URL_GET_BUSINESS_RULES: string;
  URL_INSERT_BUSINESS_RULES: string;
  URL_DELETE_BUSINESS_RULES: string;
  URL_UPDATE_BUSINESS_RULES: string;
  URL_GET_BUSINESS_NETWORK: string;
  URL_GET_TARRIF_ID: String;
  URL_GET_CAMPAIGN_COUNTRY: String;
  URL_GET_CAMPAIGN_NETWORK: String;
  URL_GET_CAMPAIGN_TADIG: string;  
  URL_GET_REPORT: string;  
  URL_GET_SUBSCRIBER_INFO: string;  
  URL_GET_HISTORY: string;  
  URL_GET_CONFIGURE: string;  
  URL_GET_VIEW_CONFIGURE: string;  
  URL_GET_SUMMARY_GROWTH: string;  
  URL_GET_SUMMARY_OVERVIEW: string;  
  URL_GET_SUMMARY_GRAPHS: string;  
  URL_GET_SMS_PDP_DAY_WISE_REPORTS: string;  
  URL_GET_RRMS_DAY_WISE_REPORTS: string; 
  URL_UNBLOCK_SMS_PDP: string; 
  URL_DELETE_SUBSCRIBER_OFFER: string; 
  URL_DOWNLOAD_SUBSCRIBER_INFO_DATA: string; 
  URL_DOWNLOAD_SMS_PDP_DATA: string; 
  CENTRY_LOG:string;
  SMSPDP_REPITIVE_COUNT_HISTORY:string;
  VLRID_UNBLOCK_COUNT:string;
  ECOWAS_ACTIVE_DEACTIVE_API:string;
  SMSPDP_UNBLOCK_API:string;

  SMSPDP_BLOCK_API:string;
  URL_RRMS_MSISDN_COUNT_REPORTS: string; 
  URL_RRMS_DATEWISE_MSISDN_COUNT_REPORTS: string; 
  URL_RRMS_PACK_ACTIVATION_SUCCESS_REPORTS:string;
  URL_RRMS_PACK_ACTIVATION_FAILURE_REPORTS:string;
  URL_RRMS_PACK_DEACTIVATION_SUCCESS_REPORTS:string;
  URL_RRMS_PACK_DEACTIVATION_FAILURE_REPORTS:string;

  
  URL_SMSPDP_MSISDN_COUNT_FOR_BLOCKED_REPORTS: string; 
  URL_SMSPDP_MSISDN_COUNT_FOR_UNBLOCKED_REPORTS: string; 
  URL_SMSPDP_DATA_SERVICE_BLOCK_SUCCESS_REPORTS: string; 
  URL_SMSPDP_DATA_SERVICE_UNBLOCK_SUCCESS_REPORTS: string; 
  URL_SMSPDP_DATA_SERVICE_BLOCK_FAILURE_REPORTS: string; 
  URL_SMSPDP_DATA_SERVICE_UNBLOCK_FAILURE_REPORTS: string; 
  URL_SMSPDP_SMS_MO_BLOCK_SUCCESS_REPORTS: string; 
  URL_SMSPDP_SMS_MO_UNBLOCK_SUCCESS_REPORTS: string; 
  URL_SMSPDP_SMS_MO_BLOCK_FAILURE_REPORTS: string; 
  URL_SMSPDP_SMS_MO_UNBLOCK_FAILURE_REPORTS: string; 
  
  URL_SMSPDP_DATEWISE_MSISDN_COUNT_FOR_BLOCKED_REPORTS: string; 
  URL_SMSPDP_DATEWISE_MSISDN_COUNT_FOR_UNBLOCKED_REPORTS: string; 

  URL_GET_VPMN_TADIGS: string; 
  URL_GET_ROLE_NAME:string;

  URL_GET_RRMS_SERVICE_LIVE_DATA:string;
  URL_GET_SMSPDP_SERVICE_LIVE_DATA:string;

  URL_GET_BUSINESS_CONFIG:string;
  URL_GET_ECOWAS_CONFIG:string;
  URL_GET_ECOWAS_WHITELIST_CONFIG:string;
  URL_GET_PROBE_CONFIG:String;
  URL_GET_ECOWAS_ORGANIZATION_CONFIG:string;
  URL_GET_ECOWAS_IN:string;

  URL_GET_SMSPDP_CONFIG:string;
  URL_GET_SMSPDP_ECOWAS_CONFIG:string;
  URL_GET_SMSPDP_LIVE_MAPPING:string;
  URL_GET_THRESHOLD_CONFIG:string


  URL_UPDATE_BUSINESS_CONFIG:string;
  URL_UPDATE_ECOWAS_CONFIG:string;
  URL_UPDATE_WHITELIST_CONFIG:string;
  URL_UPDATE_PROBE_CONFIG:string;
  URL_UPDATE_ECOWAS_ORGANIZATION_CONFIG:string;
  URL_UPDATE_ECOWAS_IN:string;
  

  URL_UPDATE_SMSPDP_CONFIG:string;
  URL_UPDATE_SMSPDP_ECOWAS_CONFIG:string;
  URL_UPDATE_SMSPDP_LIVE_MAPPING:string;
  URL_UPDATE_THRESHOLD_CONFIG:string;

  URL_DELETE_BUSINESS_CONFIG:string;
  URL_DELETE_WHITELIST_CONFIG:string;
  URL_DELETE_ECOWAS_CONFIG:string;
  URL_DELETE_PROBE_CONFIG:string;
  URL_DELETE_ECOWAS_ORGANIZATION_CONFIG:string;
  URL_DELETE_ECOWAS_IN_CONFIG:string;

  URL_DELETE_SMSPDP_CONFIG:string;
  URL_DELETE_ECOWAS_SMSPDP_CONFIG:string;
  URL_DELETE_SMSPDP_LIVE_MAPPING_CONFIG:string;
  URL_DELETE_SMSPDP_THRESOLD_CONFIG:string;


  URL_ADD_BUSINESS_CONFIG:string;
  URL_ADD_WHITELIST_CONFIG:string;
  URL_ADD_ECOWAS_CONFIG:string;
  URL_ADD_PROBE_CONFIG:string;
  URL_ADD_ECOWAS_ORGANIZATION_CONFIG:string;
  URL_ADD_ECOWAS_IN_CONFIG:string;

  URL_ADD_SMSPDP_CONFIG:string;
  URL_ADD_ECOWAS_SMSPDP_CONFIG:string;
  URL_ADD_SMSPDP_LIVE_MAPPING_CONFIG:string;
  URL_ADD_SMSPDP_THRESOLD_CONFIG:string;

  URL_DELETE_RRMS_TABLEDATA:string;
  URL_DELETE_SMSPDP_TABLEDATA:string;

  URL_ADD_RRMS_COUNTRYDATA:string;
  URL_ADD_SMSPDP_COUNTRYDATA:string;


  URL_GET_ECOWAS_ALLOWED_GT:string;
  URL_GET_ECOEAS_CC_NDC:string;
  URL_GET_ECOWAS_MCC_MNC:string;
  URL_GET_ECOWAS_THRESHOLD_CONFIG:String;
  URL_GET_RRMS_PROBRDB_ALLOWED_GT:String;
  URL_GET_RRMS_PROBDB_CC_NDC:String;
  URL_GET_RRMS_PROBDB_MCC_MNC:String;
  URL_GET_RRMS_PROBDB_ORGANIZATION:String;

  URL_UPDATE_ECOWAS_ALLOWED_GT:string;
  URL_UPDATE_ECOEAS_CC_NDC:string;
  URL_UPDATE_ECOWAS_MCC_MNC:string;
  URL_UPDATE_ECOWAS_THRESHOLD_CONFIG:String;
  URL_UPDATE_RRMS_PROBRDB_ALLOWED_GT:String;
  URL_UPDATE_RRMS_PROBDB_CC_NDC:String;
  URL_UPDATE_RRMS_PROBDB_MCC_MNC:String;
  URL_UPDATE_RRMS_PROBDB_ORGANIZATION:String;


  URL_ADD_ECOWAS_ALLOWED_GT:string;
  URL_ADD_ECOEAS_CC_NDC:string;
  URL_ADD_ECOWAS_MCC_MNC:string;
  URL_ADD_ECOWAS_THRESHOLD_CONFIG:String;
  URL_ADD_RRMS_PROBRDB_ALLOWED_GT:String;
  URL_ADD_RRMS_PROBDB_CC_NDC:String;
  URL_ADD_RRMS_PROBDB_MCC_MNC:String;
  URL_ADD_RRMS_PROBDB_ORGANIZATION:String;


  URL_DELETE_ECOWAS_ALLOWED_GT:string;
  URL_DELETE_ECOEAS_CC_NDC:string;
  URL_DELETE_ECOWAS_MCC_MNC:string;
  URL_DELETE_ECOWAS_THRESHOLD_CONFIG:String;
  URL_DELETE_RRMS_PROBRDB_ALLOWED_GT:String;
  URL_DELETE_RRMS_PROBDB_CC_NDC:String;
  URL_DELETE_RRMS_PROBDB_MCC_MNC:String;
  URL_DELETE_RRMS_PROBDB_ORGANIZATION:String;


  URL_UPLOAD_RRMS_SERVICE_LIVE_DATA:string;
  URL_GET_UPLOAD_RRMS_SERVICE_LIVE_DATA:String;

  URL_COUNTRY_FOR_NETWORK_ADDITION:string;
  URL_GET_NETWORK_ADDITION:string;
  URL_ADD_NETWORK_ADDITION:string;
  URL_UPDATE_NETWORK_ADDITION:string;
  URL_DELETE_NETWORK_ADDITION:string;
  URL_GET_NETWORK_FOR_SELECTED_COUNTRY:string;
  URL_GET_SMSPDP_LIVE_MAPPING_DATA: string;
  constructor(private configService: ConfigService) {
    this.API_BASE_URL = this.configService.apiBaseUrl;
    this.URL_GET_SIM_CARD_DATA = this.API_BASE_URL + 'SimCardCenterServlet?reportType=getSimCardCenter';
    this.URL_GET_CREDIT_DATA = this.API_BASE_URL + 'CreditMonitorServlet?reportType=getCreditInfo';
    this.URL_GET_COUNTRY_LIST = this.API_BASE_URL + 'SimCardCenterServlet?reportType=getCountryList';
    this.URL_GET_TAP_CODE_LIST = this.API_BASE_URL + 'SimCardCenterServlet?reportType=getTapCodeList';
    this.URL_GET_OPERATOR_LIST = this.API_BASE_URL + 'SimCardCenterServlet?reportType=getOperator';
    this.URL_INSERT_SIM_CARD_DATA = this.API_BASE_URL + 'SimCardCenterServlet?reportType=insertSimCardCenter';
    this.URL_UPDATE_SIM_CARD_DATA = this.API_BASE_URL + 'SimCardCenterServlet?reportType=updateSimCardCenter';
    this.URL_DELETE_SIM_CARD_DATA = this.API_BASE_URL + 'SimCardCenterServlet?reportType=deleteSimDetails';
    this.URL_SEND_MAIL = this.API_BASE_URL + 'SimCardCenterServlet?reportType=insertMailHistory';
    this.URL_GET_OPERATOR_LIST_BY_COUNTRY = this.API_BASE_URL + 'TarrifServlet?reportType=getOperator';
    this.URL_GET_CREDIT_INFO = this.API_BASE_URL + 'CreditMonitorServlet?reportType=getCreditInfo';
    this.URL_GET_CREDIT_USAGE_INFO = this.API_BASE_URL + 'CreditMonitorServlet?reportType=getCreditUsage';
    this.URL_GET_AFFILIATE_LIST_ORDER = this.API_BASE_URL + 'OrderManagementServlet?reportType=getTapCodeList';
    this.URL_INSERT_ORDER = this.API_BASE_URL + 'OrderManagementServlet?reportType=insertOrderDetails';
    this.URL_UPDATE_ORDER = this.API_BASE_URL + 'OrderManagementServlet?reportType=updateOrderDetails';
    this.URL_DELETE_ORDER = this.API_BASE_URL + 'OrderManagementServlet?reportType=deleteOrderDetails';
    this.URL_GET_ORDER = this.API_BASE_URL + 'OrderManagementServlet?reportType=getOrderDetails';
    this.URL_INSERT_ORDER_REMINDER = this.API_BASE_URL + 'OrderManagementServlet?reportType=insertOrderReminder';
    this.URL_UPDATE_ORDER_REMINDER = this.API_BASE_URL + 'OrderManagementServlet?reportType=updateOrderReminder';
    this.URL_GET_ORDER_REMINDER = this.API_BASE_URL + 'OrderManagementServlet?reportType=getOrderReminder';
    this.URL_DELETE_ORDER_REMINDER = this.API_BASE_URL + 'OrderManagementServlet?reportType=deleteReminder';
    this.URL_GET_AUDIT = this.API_BASE_URL + 'AuditServlet?reportType=getAuditDetails';
    this.URL_INSERT_AUDIT = this.API_BASE_URL + 'AuditServlet?reportType=insertAuditDetails';
    this.URL_GET_IR21DATA = this.API_BASE_URL + 'IRDocServlet?reportType=getIr21Files';
    this.URL_GET_IR21DATA_OPENFILE = this.API_BASE_URL + 'IRDocServlet?reportType=getIr21Files';
    this.URL_GET_DELETE_IR21_FILE = this.API_BASE_URL + 'IRDocServlet?reportType=deleteFile';
    this.URL_INSERT_FILE = this.API_BASE_URL + 'UploadServlet';
    this.URL_GET_NETWORK_CENTER = this.API_BASE_URL + 'NetworkServlet?reportType=getNetworkInfos';
    this.URL_GET_NETWORK_CENTER_API = this.API_BASE_URL + 'NetworkServlet?reportType=getNetworkInfos';
    this.URL_UPLOAD_CORE_FILE = this.API_BASE_URL + 'UploadCoreServlet';
    this.URL_AUDIT_COMPARISON = this.API_BASE_URL + 'AuditServlet?reportType=getAuditComparison';
    this.URL_GET_AUDIT_NAME = this.API_BASE_URL + 'AuditServlet?reportType=getAuditName';
    this.URL_GET_TAP_CODE_MULTI = this.API_BASE_URL + 'SimCardCenterServlet?reportType=getTapCodeMulti';
    this.URL_UPDATE_AUDIT = this.API_BASE_URL + 'AuditServlet?reportType=updateAuditDetails';
    this.URL_INSERT_REMINDER_AUDIT = this.API_BASE_URL + 'AuditServlet?reportType=insertAuditReminder';
    this.URL_GET_AUDIT_REMINDER = this.API_BASE_URL + 'AuditServlet?reportType=getAuditReminder';
    this.URL_NETWORK_CENTER_EMAIL = this.API_BASE_URL + 'NetworkServlet?reportType=insertNetworkReminder';
    this.URL_INSERT_ORDER_REMINDER = this.API_BASE_URL + 'OrderManagementServlet?reportType=insertOrderReminder';
    this.URL_GET_NODE_INFO = this.API_BASE_URL + 'IRDocServlet?reportType=nodeDetails';
    this.URL_APP_LOGIN = this.API_BASE_URL + 'LoginServlet';
    this.URL_APP_RESET_PASSWORD = this.API_BASE_URL + 'LoginServlet?reportType=ForgotPassword';
    this.URL_INSERT_SERVICE_OPEN = this.API_BASE_URL + 'ServiceServlet?reportType=insertService';
    this.URL_UPDATE_SERVICE_OPEN = this.API_BASE_URL + 'ServiceServlet?reportType=updateSubService';
    this.URL_GET_SERVICE_OPEN = this.API_BASE_URL + 'ServiceServlet?reportType=getServiceOpen';
    this.URL_INSERT_SERVICE_OPEN_EMAIL = this.API_BASE_URL + 'ServiceServlet?reportType=insertMailHistory';
    this.URL_GET_SERVICE_EMAIL_HISTORY = this.API_BASE_URL + 'ServiceServlet?reportType=getMailHistory';
    this.URL_SERVICE_OPEN_INSERT_REMINDER = this.API_BASE_URL + 'ServiceServlet?reportType=insertAuditReminder';
    this.URL_SERVICE_OPEN_GET_REMINDER = this.API_BASE_URL + 'ServiceServlet?reportType=getServiceReminder';
    this.URL_GET_SERVICES = this.API_BASE_URL + 'ServiceServlet?reportType=getServices';
    this.URL_GET_SERVICE_OPENING = this.API_BASE_URL + 'ServiceServlet?reportType=getServiceOpening';
    this.URL_ADD_SERVICE_COMMENT = this.API_BASE_URL + 'ServiceServlet?reportType=addComments';
    this.URL_VIEW_SERVICE_COMMENT = this.API_BASE_URL + 'ServiceServlet?reportType=viewComments';
    this.URL_SERVICE_OPEN_GET_CONTACTS = this.API_BASE_URL + 'ServiceServlet?reportType=getContacts';
    this.URL_SERVICE_OPEN_UPLOAD = this.API_BASE_URL + 'UploadServiceServlet';
    this.URL_SERVICE_OPEN_GET_DOCUMENTS = this.API_BASE_URL + 'ServiceServlet?reportType=getDocuments';
    this.URL_GET_SERVICE_MONITOR = this.API_BASE_URL + 'NetworkLiveListServlet?reportType=getNetworkMonitorInfo';
    this.URL_GET_SERVICE_MONITOR_SECOND = this.API_BASE_URL + 'NetworkLiveListServlet?reportType=monitorsecond';
    this.URL_GET_SERVICE_TRACKER = this.API_BASE_URL + 'NetworkLiveListServlet?reportType=getServiceTrackerInfo';
    this.URL_GET_SERVICE_TRACKER_GRAPH = this.API_BASE_URL + 'NetworkLiveListServlet?reportType=getServiceTrackerInfo2nd';
    this.URL_GET_HEAT_MAP_ONE = this.API_BASE_URL + 'NetworkLiveListServlet?reportType=getServiceListReport1';
    this.URL_GET_HEAT_MAP_TWO = this.API_BASE_URL + 'NetworkLiveListServlet?reportType=getServiceListReport3';
    this.URL_GET_HEAT_MAP_ONE_REPORT_ONE = this.API_BASE_URL + 'NetworkLiveListServlet?reportType=getServiceListReport2';
    this.URL_GET_HEAT_MAP_ONE_REPORT_TWO = this.API_BASE_URL + 'NetworkLiveListServlet?reportType=getServiceListReport2';
    this.URL_GET_HEAT_MAP_TWO_REPORT_ONE = this.API_BASE_URL + 'NetworkLiveListServlet?reportType=getServiceListReport4';
    this.URL_GET_HEAT_MAP_TWO_REPORT_TWO = this.API_BASE_URL + 'ServiceServlet?reportType=getServiceOpen';
    // this.URL_EMAIL_WITH_ATTACHMENT = this.configService.apiBaseUrlEmail + 'notification/mail-with-attachment';
    this.URL_EMAIL_WITH_ATTACHMENT = this.API_BASE_URL + 'MTNEmailServletAttachment';
    this.URL_GET_AUDIT_SUMMARY = this.API_BASE_URL + 'AuditServlet?reportType=getAuditSummary';
    this.URL_GET_AUDIT_MATCH_DETAILS = this.API_BASE_URL + 'AuditServlet?reportType=getAuditMatchVersion';
    this.URL_GET_EMAIL_LIST = this.API_BASE_URL + 'SimCardCenterServlet?reportType=getEmailList';

    this.URL_GET_REGION_LIST = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=getRegionInfo';
    this.URl_GET_DEAL_ID = this.API_BASE_URL + 'DealServlet?reportType=getDealId';
    this.URL_GET_COUNTRY_BY_REGION = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=getCountryInfo';
    this.URL_GET_TAGID_BY_COUNTRY = this.API_BASE_URL + 'MasterInfoServlet?reportType=getOrganizationByCountry';
    this.URl_GET_DEAL_RELATION = this.API_BASE_URL + 'DealServlet?reportType=getDealRelationInfo';
    this.URL_GET_DEAL_TABLE_DATA = this.API_BASE_URL + 'DealServlet?reportType=getDealTableData';
    this.URL_SAVE_DEAL_INFO = this.API_BASE_URL + 'DealServlet?reportType=dealOpening';
    this.URL_GET_DEAL_INFO = this.API_BASE_URL + 'DealCenterServlet?reportType=getDealCenterData';
    this.URL_GET_OVERVIEW_DATA = this.API_BASE_URL + 'DealDasServlet?reportType=getDealOverView';
    this.URL_GET_LATEST_DEAL = this.API_BASE_URL + 'DealDasServlet?reportType=getLatestDeal';
    this.URL_GET_DEAL_NOTIFICATION = this.API_BASE_URL + 'DealDasServlet?reportType=getMyNotifications';
    this.URL_GET_DEAL_INFO_CONTACT = this.API_BASE_URL + 'DealServlet?reportType=getMemberOfDeal';
    this.URL_GET_CONTACT_MANAGEMENT = this.API_BASE_URL + 'DealServlet?reportType=getContactManagment';
    this.URL_GET_DEAL_COVERAGE = this.API_BASE_URL + 'DealCenterServlet?reportType=getDealCoverage';
    this.URL_GET_DEAL_SUMMARY = this.API_BASE_URL + 'DealServlet?reportType=getDealSummary';
    this.URL_UPDATE_DEAL_STATUS = this.API_BASE_URL + 'DealServlet?reportType=updateDealStatus';
    this.URL_GET_CONTACT_DETAILS = this.API_BASE_URL + 'DealServlet?reportType=getContactDetails';
    this.URL_SEND_DEAL_MAIL = this.API_BASE_URL + 'DealServlet?reportType=sendIOTEmail';
    this.URL_GET_MARKET_PERFORMANCE_INFO = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=getMpCountryInfo';
    this.URL_GET_MARKET_PERFORMANCE_OPERTOR_VPMN_NETWORK = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=getVPMNNetworkName';
    this.URL_GET_MARKET_PERFORMANCE_OPERTOR_MEMBER_OF_DEAL_NETWORK = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=getMemberOfDeal';
    this.URL_GET_DEAL_EVOLUTION = this.API_BASE_URL + 'DealServlet?reportType=getDealEvolution';
    this.URL_GET_MARKET_PERFORMANCE_TRFFIC = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=getTraffic';
    this.URL_GET_MARKET_PERFORMANCE_IOT = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=getIots';
    this.URL_GET_MARKET_TRACKER = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=marketTracker';
    this.URL_GET_DEAL_APPROVER = this.API_BASE_URL + 'DealServlet?reportType=getDealApprover';
    this.URL_GET_PERFORMANCE_CHART = this.API_BASE_URL + 'DealServlet?reportType=getSummaryPerformance';
    this.URL_GET_METRICES_CHART = this.API_BASE_URL + 'DealServlet?reportType=getMetrics';
    this.URL_GENERATE_EXCEL = this.API_BASE_URL + 'DealServlet?reportType=generateExcel';
    this.URL_GET_PERFORMANCE_TABLE = this.API_BASE_URL + 'DealServlet?reportType=getSummaryTab1';
    this.URL_GET_METRIC_TABLE = this.API_BASE_URL + 'DealServlet?reportType=getMetricTab1';
    this.URL_GET_INBOUND_PERFORMANCE_CHART = this.API_BASE_URL + 'DealServlet?reportType=getDealInfoPerformance';
    this.URL_GET_INBOUND_PERFORMANCE_TABLE = this.API_BASE_URL + 'DealServlet?reportType=getSummaryTab2';
    this.URL_GET_INBOUND_TRAFFIC_TABLE = this.API_BASE_URL + 'DealServlet?reportType=getDealInfoTraffic';
    this.URL_GET_DEAL_SUMMARY_DATA = this.API_BASE_URL + 'DealServlet?reportType=getDealSummaryData';
    this.URL_GET_MARKET_SIMULATOR = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=marketSimulator';
    this.URL_GET_MARKET_PERFORMANCE_DEAL_GRAPH = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=getMarketPerformanceDeal';
    this.URL_GET_ORDER_NAME = this.API_BASE_URL + 'OrderManagementServlet?reportType=getOrderName';
    this.URL_BULK_SIM_UPLOAD = this.API_BASE_URL + 'SimBulkUploadServlet';
    this.URL_GET_NETWORK_FILE_WO_SNO = this.API_BASE_URL + 'IRDocServlet?reportType=getIr21FilesWithOutSno';
    this.URL_COMMITMENT_GRAPH_DATA = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=getMarketPerformanceDealCommitment';
    this.URL_MARKET_PERFORMANCE_DEAL_OF_MEMBERS = this.API_BASE_URL + 'DealServlet?reportType=getMemberOfDeal';
    this.URL_MARKET_PERFORMANCE_CHARGES = this.API_BASE_URL + 'MarketPerformanceServlet?reportType=marketCharges';
    this.URL_GET_COUNTRY_INDIVIDUAL = this.API_BASE_URL + 'SimCardCenterServlet?reportType=getCountry';
    this.URl_GET_RETAIL = this.API_BASE_URL + 'ProductDBServlet?reportType=getRetailCenter';
    this.URL_GET_POSTPAID_PRODUCT = this.API_BASE_URL + 'ProductDBServlet?reportType=getProductDB';
    this.URL_GET_CONSUMER_CALL_MOC = this.API_BASE_URL + 'ProductDBServlet?reportType=getProductDBConsumerCallMoc';
    this.URL_GET_CONSUMER_CALL_MTC_GPRS_MESSAGING = this.API_BASE_URL + 'ProductDBServlet?reportType=getProductDBConsumerCallMtcGprsMessage';
    this.URL_UPDATE_CONSUMER_CALL_MTC_GPRS_MESSAGING = this.API_BASE_URL + 'ProductDBServlet?reportType=updateProductDBConsumerMtcGprsMessage';
    this.URL_INSERT_CONSUMER_CALL_MTC_GPRS_MESSAGING = this.API_BASE_URL + 'ProductDBServlet?reportType=insertProductDBConsumerMtcGprsMessage';
    this.URL_ADD_PRODUCT = this.API_BASE_URL + 'ProductDBServlet?reportType=insertProductDB';
    this.URL_UPDATE_PRODUCT = this.API_BASE_URL + 'ProductDBServlet?reportType=updateProductDB';
    this.URL_DELETE_PRODUCT = this.API_BASE_URL + 'ProductDBServlet?reportType=deleteProductDB';
    this.URL_DELETE_POSTPAID = this.API_BASE_URL + 'ProductDBServlet?reportType=deletePostpaidProductDB';
    this.URL_ADD_CAMPAIGN = this.API_BASE_URL + 'CampaignServlet?requestType=insertCampaignNew';
    this.URL_GET_CAMPAIGN = this.API_BASE_URL + 'CampaignServlet?requestType=getCampaign';
    this.URL_DELETE_CAMPAIGN = this.API_BASE_URL + 'CampaignServlet?requestType=deleteCampaign';
    this.URL_EDIT_CAMPAIGN = this.API_BASE_URL + 'CampaignServlet?requestType=updateCampaigNew';
    this.URL_GET_ZONES = this.API_BASE_URL + 'ProductDBServlet?reportType=getZones';
    this.URL_GET_COUNTRY_BY_ZONES = this.API_BASE_URL + 'ProductDBServlet?reportType=getZonesCountry';
    this.URL_GET_DOCUMENT_REPOSITORY = this.API_BASE_URL + 'DocumentServlet?reportType=getDocument';
    this.INSERT_DOCUMENT_REPOSITORY = this.API_BASE_URL + 'DocumentServlet?reportType=uploadFile';

    this.ROAMERS_SEGMENT_DETAILS = this.API_BASE_URL + 'ReportDataServlet?reportType=getRoamersSegmentationHistory';
    this.ROAMERS_SEGMENT_COUNT_HISTORY = this.API_BASE_URL + 'ReportDataServlet?reportType=getRoamersCountHistory';
    this.PRICE_POINT_HISTORY = this.API_BASE_URL + 'ReportDataServlet?reportType=getPricePointHistory';
    // this.ROAMERS_PACK_HISTORY = this.API_BASE_URL + 'GraphDataServlet?reportType=getPackActivatedHistory';
    this.ROAMERS_PACK_HISTORY = this.API_BASE_URL + 'ReportDataServlet?reportType=RoamFreeReport';
    this.ROAMERS_ERROR_CODE_REPORT = this.API_BASE_URL + 'ReportDataServlet?reportType=RoamFree IN Error Code Report';
    this.STATISTICS_REPORT = this.API_BASE_URL + 'ReportDataServlet?reportType=IN Statistics Report';
    this.MESSAGE_DELIVERY_STATIC=this.API_BASE_URL +'ReportDataServlet?reportType=Message%20Delivery%20Statistics%20Report';
    this.MESSAGE_COUNT_HISTORY=this.API_BASE_URL +'ReportDataServlet?reportType=Message%20Count%20Report';
    this.COUNTRY_DETAILS=this.API_BASE_URL +'TarrifServlet?reportType=getCountry';
    this.NETWORK_DETAILS=this.API_BASE_URL +'CampaignServlet?reportType=getOperator';
    this.URL_GET_TARRIFF=this.API_BASE_URL +'TarrifServlet?reportType=getTariff';
    this.INSERT_TARRIFF = this.API_BASE_URL + 'TarrifServlet?reportType=insertTariff';
    this.URL_GET_WHITELIST=this.API_BASE_URL +'WhiteListServlet?reportType=getWhiteList';
    this.INSERT_WHITELIST = this.API_BASE_URL + 'WhiteListServlet?reportType=insertWhiteList';
    this.INSERT_BLACKLIST = this.API_BASE_URL + 'BlackListServlet?reportType=insertBlackList';
    this.URL_GET_BLACKLIST=this.API_BASE_URL +'BlackListServlet?reportType=getBlackList';
    this.URL_DELETE_BLACKLIST=this.API_BASE_URL +'BlackListServlet?reportType=deleteBlackList';
    this.URL_UPDATE_BLACKLIST=this.API_BASE_URL +'BlackListServlet?reportType=updateBlackList';
    this.URL_UPDATE_TARRIFF = this.API_BASE_URL + 'TarrifServlet?reportType=updateTariff';
    this.URL_DELETE_TARRIFF = this.API_BASE_URL + 'TarrifServlet?reportType=deleteTariff';
    this.URL_UPDATE_WHITELIST = this.API_BASE_URL + 'WhiteListServlet?reportType=updateWhiteList';
    this.URL_DELETE_WHITELIST = this.API_BASE_URL + 'WhiteListServlet?reportType=deleteWhiteList';
    this.URL_GET_BLACKLIST=this.API_BASE_URL +'BlackListServlet?reportType=getBlacklist';
    this.URL_GET_ECOWAS_BUSINESS_RULE=this.API_BASE_URL +'BussinessRuleServlet?reportType=getEcowasBussinessRule';
    this.INSERT_ECOWAS_BUSINESS_RULE = this.API_BASE_URL + 'BussinessRuleServlet?reportType=insertEcowasBussinessRule';
    this.URL_GET_COMMUNITY_NETWORK = this.API_BASE_URL + 'CampaignServlet?reportType=getVisitingCountryCommunity';
    this.URL_GET_COMMUNITY_COUNTRY = this.API_BASE_URL + 'CampaignServlet?reportType=getHomeCountryCommunity';
    this.URL_GET_COMMUNITY = this.API_BASE_URL + 'CampaignServlet?reportType=getCommunity';
    this.URL_INSERT_COMMUNITY = this.API_BASE_URL + 'CampaignServlet?reportType=insertCommunity';
    this.URL_DELETE_COMMUNITY = this.API_BASE_URL + 'CampaignServlet?reportType=deleteCommunity';
    this.URL_UPDATE_COMMUNITY = this.API_BASE_URL + 'CampaignServlet?reportType=updateCommunity'
    this.URL_GET_BUSINESS_RULES = this.API_BASE_URL + 'BussinessRuleServlet?reportType=getEcowasBussinessRule';
    this.URL_INSERT_BUSINESS_RULES = this.API_BASE_URL + 'BussinessRuleServlet?reportType=insertEcowasBussinessRule';
    this.URL_DELETE_BUSINESS_RULES = this.API_BASE_URL + 'BussinessRuleServlet?reportType=deleteEcowasBussinessRule';
    this.URL_UPDATE_BUSINESS_RULES = this.API_BASE_URL + 'BussinessRuleServlet?reportType=updateEcowasBussinessRule';
    this.URL_GET_BUSINESS_NETWORK = this.API_BASE_URL + 'CampaignServlet?reportType=getVisitingCountryCommunity';
    this.URL_GET_TARRIF_ID = this.API_BASE_URL +'TarrifServlet?reportType=getTariff';
    this.URL_GET_CAMPAIGN_COUNTRY = this.API_BASE_URL +'CampaignServlet?requestType=getCountryList';
    this.URL_GET_CAMPAIGN_NETWORK = this.API_BASE_URL +'CampaignServlet?requestType=getOperator';
    this.URL_GET_CAMPAIGN_TADIG = this.API_BASE_URL +'CampaignServlet?requestType=getTapCodeList';
    this.URL_GET_REPORT = this.API_BASE_URL +'ReportDataServlet?reportType=getMsisdnLogs';
    this.URL_GET_SUBSCRIBER_INFO = this.API_BASE_URL +'ReportDataServlet?reportType=getSubscriberActiveInfo';
    this.URL_GET_CAMPAIGN_TABLE = this.API_BASE_URL +'CampaignServlet?requestType=getCampaign';
    this.URL_GET_HISTORY = this.API_BASE_URL +'SMSPDPConfigure?reportType=history';
    this.URL_GET_CONFIGURE = this.API_BASE_URL +'SMSPDPConfigure?reportType=configure';    
    this.URL_GET_VIEW_CONFIGURE = this.API_BASE_URL +'SMSPDPConfigure?reportType=viewconfigure';    
    this.URL_GET_SUMMARY_GROWTH = this.API_BASE_URL +'ReportDataServlet?reportType=monthlyPerfomanceDetails';    
    this.URL_GET_SUMMARY_OVERVIEW = this.API_BASE_URL +'SummaryServlet?reportType=getSummaryOverView';    
    this.URL_GET_SUMMARY_GRAPHS = this.API_BASE_URL +'ReportDataServlet?reportType=graphDataForSummaryPage';    
    this. URL_GET_SMS_PDP_DAY_WISE_REPORTS = this.API_BASE_URL +'SMSPDPConfigure?reportType=dayWiseReports';    
    this. URL_GET_RRMS_DAY_WISE_REPORTS = this.API_BASE_URL +'ReportDataServlet?reportType=rrmsDayWiseReports';    
    this.URL_UNBLOCK_SMS_PDP = this.API_BASE_URL +'EcowasInInterface/UnBlockSmsPdpServlet?';
    this.URL_DELETE_SUBSCRIBER_OFFER = this.API_BASE_URL +'EcowasInInterface/DeleteOfferServlet?DeleteOfferServlet?';
    this.URL_DOWNLOAD_SUBSCRIBER_INFO_DATA = this.API_BASE_URL +'ReportDataServlet?reportType=getSubscriberPackdpHistoryDownload';
    this.URL_DOWNLOAD_SMS_PDP_DATA = this.API_BASE_URL +'ReportDataServlet?reportType=getSmsPdpHistoryDownload';
    this.CENTRY_LOG = this.API_BASE_URL+'UserAnalytics?';
    this.REPITIVE_COUNT_HISTORY=this.API_BASE_URL +'ReportDataServlet?reportType=getEcowasOfferExchangesBetweenBorderNetwork';
    this.SMSPDP_REPITIVE_COUNT_HISTORY = this.API_BASE_URL +'ReportDataServlet?reportType=getSMSPDPOfferExchangesBetweenBorderNetwork';
    this.VLRID_UNBLOCK_COUNT = this.API_BASE_URL+'ReportDataServlet?reportType=getVlridUnblockCount';
    this.ECOWAS_ACTIVE_DEACTIVE_API = this.API_BASE_URL+'SubscriberFilterServlet?reportType=activedeactivesubscriber';
    this.SMSPDP_UNBLOCK_API = this.API_BASE_URL+'SubscriberFilterServlet?reportType=smspdpunblock';
    this.SMSPDP_BLOCK_API = this.API_BASE_URL+'SubscriberFilterServlet?reportType=smspdpblock';
    this.URL_RRMS_MSISDN_COUNT_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=msisdnCountReport';
    this.URL_RRMS_DATEWISE_MSISDN_COUNT_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=msisdnCountReportTime';
    this.URL_RRMS_PACK_ACTIVATION_SUCCESS_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=packActivationReport';
    this.URL_RRMS_PACK_ACTIVATION_FAILURE_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=packActivationFailReport';
    this.URL_RRMS_PACK_DEACTIVATION_SUCCESS_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=packDeActivationReport';
    this.URL_RRMS_PACK_DEACTIVATION_FAILURE_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=packDeActivationFailReport';

    
    this.URL_SMSPDP_MSISDN_COUNT_FOR_BLOCKED_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpBlockedMsisdnCountReport';
    this.URL_SMSPDP_MSISDN_COUNT_FOR_UNBLOCKED_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpUnBlockedMsisdnCountReport';
    this.URL_SMSPDP_DATA_SERVICE_BLOCK_SUCCESS_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpDataSuccessBlockedCountReport';
    this.URL_SMSPDP_DATA_SERVICE_UNBLOCK_SUCCESS_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpDataSuccessUnBlockedCountReport';
    this.URL_SMSPDP_DATA_SERVICE_BLOCK_FAILURE_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpDataFailBlockedCountReport';
    this.URL_SMSPDP_DATA_SERVICE_UNBLOCK_FAILURE_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpDataFailUnBlockedCountReport';
    this.URL_SMSPDP_SMS_MO_BLOCK_SUCCESS_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpSmSuccessBlockedCountReport';
    this.URL_SMSPDP_SMS_MO_UNBLOCK_SUCCESS_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpSmSuccessUnBlockedCountReport';
    this.URL_SMSPDP_SMS_MO_BLOCK_FAILURE_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpSmSFailBlockedCountReport';
    this.URL_SMSPDP_SMS_MO_UNBLOCK_FAILURE_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpSmsFailUnBlockedCountReport';
  
    this.URL_SMSPDP_DATEWISE_MSISDN_COUNT_FOR_BLOCKED_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpBlockedMsisdnCountReportTime';
    this.URL_SMSPDP_DATEWISE_MSISDN_COUNT_FOR_UNBLOCKED_REPORTS = this.API_BASE_URL +'ReportLatestDataServlet?reportType=smsPdpUnBlockedMsisdnCountReportTime';
   
    
    this.URL_GET_VPMN_TADIGS = this.API_BASE_URL + 'SimCardCenterServlet?reportType=getVpmnTadigs';
    this.URL_GET_ALL_USERS = this.API_BASE_URL + 'UserServlet?reportType=getallusers';
    this.URL_GET_ROLE_NAME = this.API_BASE_URL + 'UserServlet?reportType=getAllRoleNamesWithReports';
    this.URL_UPDATE = this.API_BASE_URL + 'UserServlet?reportType=updateRole';
    this.URL_CREATE_USER = this.API_BASE_URL + 'UserServlet?reportType=createUser'
    this.URL_DELETE_USER = this.API_BASE_URL + 'UserServlet?reportType=deleteuser';
    this.URL_DELETE_ROLE = this.API_BASE_URL + 'UserServlet?reportType=deleteRole';
    this.URL_INSERT_ROLE = this.API_BASE_URL + 'UserServlet?reportType=createRole';
    this.URL_UPDATE_USER = this.API_BASE_URL + 'UserServlet?reportType=updateUser';

    this.URL_GET_BUSINESS_CONFIG = this.API_BASE_URL + 'EcowasBusinessServlet?reportType=getBusinessConfigInfo';
    this.URL_UPDATE_BUSINESS_CONFIG = this.API_BASE_URL + 'EcowasBusinessServlet?reportType=updateBusinessConfigInfoorgId';
    this.URL_GET_ECOWAS_CONFIG = this.API_BASE_URL + 'EcowasConfigServlet?reportType=getEcowasConfigInfo';
    this.URL_UPDATE_ECOWAS_CONFIG = this.API_BASE_URL + 'EcowasConfigServlet?reportType=updateeEcowasConfigInfo';
    this.URL_GET_ECOWAS_WHITELIST_CONFIG = this.API_BASE_URL + 'Ecowas_whitelistServlet?reportType=getEcowas_whitelistInfo';
    this.URL_UPDATE_WHITELIST_CONFIG = this.API_BASE_URL + 'Ecowas_whitelistServlet?reportType=updateEcowas_whitelistConfigInfo';
    this.URL_GET_PROBE_CONFIG = this.API_BASE_URL + 'EcowasProbe_ConfigServlet?reportType=getProbe_ConfigInfo';
    this.URL_UPDATE_PROBE_CONFIG = this.API_BASE_URL + 'EcowasProbe_ConfigServlet?reportType=updateProbe_ConfigInfo';
    this.URL_GET_ECOWAS_ORGANIZATION_CONFIG = this.API_BASE_URL + 'Ecowas_organizationServlet?reportType=getEcowas_organizationInfo';
    this.URL_UPDATE_ECOWAS_ORGANIZATION_CONFIG = this.API_BASE_URL + 'Ecowas_organizationServlet?reportType=updateEcowasOrganizationInfo';
    this.URL_GET_ECOWAS_IN = this.API_BASE_URL + 'EcowasInConfigServlet?reportType=getEcowasInConfigInfo';
    this.URL_UPDATE_ECOWAS_IN = this.API_BASE_URL + 'EcowasInConfigServlet?reportType=updateEcowasInConfigInfo';



    this.URL_GET_RRMS_SERVICE_LIVE_DATA = this.API_BASE_URL + 'EcowasConfigSearchServlet?reportType=getCountryDetails&table=rrms_live_mapping';
    this.URL_GET_SMSPDP_SERVICE_LIVE_DATA = this.API_BASE_URL + 'EcowasConfigSearchServlet?reportType=getCountryDetails&table=null';
    this.URL_GET_SMSPDP_LIVE_MAPPING_DATA = this.API_BASE_URL + 'EcowasConfigSearchServlet?reportType=getCountryDetails&table=smspdp_live_mapping';

    this.URL_GET_SMSPDP_CONFIG = this.API_BASE_URL + 'SmsdbConfigServlet?reportType=getSmsdbConfigInfo';
    this.URL_UPDATE_SMSPDP_CONFIG = this.API_BASE_URL + 'SmsdbConfigServlet?reportType=updateSmsdbConfigInfo';
    this.URL_GET_SMSPDP_ECOWAS_CONFIG = this.API_BASE_URL + 'Ecowas_sms_pdp_configureServlet?reportType=getEcowas_sms_pdp_configureInfo';
    this.URL_UPDATE_SMSPDP_ECOWAS_CONFIG = this.API_BASE_URL + 'Ecowas_sms_pdp_configureServlet?reportType=updateEcowas_sms_pdp_configureInfo';
    this.URL_GET_SMSPDP_LIVE_MAPPING = this.API_BASE_URL + 'EcowasSmsPdp_Live_MappingServlet?reportType=getEcowasSmsPdp_Live_Mapping';
    this.URL_UPDATE_SMSPDP_LIVE_MAPPING = this.API_BASE_URL + 'EcowasSmsPdp_Live_MappingServlet?reportType=updateEcowasSmsPdp_Live_Mapping';
    this.URL_GET_THRESHOLD_CONFIG = this.API_BASE_URL + 'Ecowas_Threshold_ConfServlet?reportType=getEcowas_Threshold_ConfigInfo';
    this.URL_UPDATE_THRESHOLD_CONFIG = this.API_BASE_URL + 'Ecowas_Threshold_ConfServlet?reportType=updateEcowas_Threshold_ConfigInfo';

    this.URL_DELETE_BUSINESS_CONFIG = this.API_BASE_URL + 'EcowasBusinessServlet?reportType=deleteConfigureOrgId';
    this.URL_DELETE_WHITELIST_CONFIG = this.API_BASE_URL + 'Ecowas_whitelistServlet?reportType=deleteEcowas_whitelist';
    this.URL_DELETE_ECOWAS_CONFIG = this.API_BASE_URL + 'EcowasConfigServlet?reportType=deleteConfigure';
    this.URL_DELETE_PROBE_CONFIG = this.API_BASE_URL + 'EcowasProbe_ConfigServlet?reportType=deleteProbe_ConfigInfo';
    this.URL_DELETE_ECOWAS_ORGANIZATION_CONFIG = this.API_BASE_URL + 'Ecowas_organizationServlet?reportType=deleteEcowasOrganizationInfo' ;
    this.URL_DELETE_ECOWAS_IN_CONFIG = this.API_BASE_URL + 'EcowasInConfigServlet?reportType=deleteEcowasInConfigInfo';

    this.URL_DELETE_SMSPDP_CONFIG = this.API_BASE_URL + 'SmsdbConfigServlet?reportType=deleteSmsdbConfigInfo';
    this.URL_DELETE_ECOWAS_SMSPDP_CONFIG = this.API_BASE_URL + 'Ecowas_sms_pdp_configureServlet?reportType=deleteEcowas_sms_pdp_configureInfo';
    this.URL_DELETE_SMSPDP_LIVE_MAPPING_CONFIG = this.API_BASE_URL + 'EcowasSmsPdp_Live_MappingServlet?reportType=deleteEcowasSmsPdp_Live_Mapping';
    this.URL_DELETE_SMSPDP_THRESOLD_CONFIG = this.API_BASE_URL + 'Ecowas_Threshold_ConfServlet?reportType=deleteEcowas_Threshold_Config';
    
    this.URL_ADD_BUSINESS_CONFIG = this.API_BASE_URL + 'EcowasBusinessServlet?reportType=insertBusinessConfigInfoorgId';
    this.URL_ADD_WHITELIST_CONFIG = this.API_BASE_URL + 'Ecowas_whitelistServlet?reportType=insertWhitelist';
    this.URL_ADD_ECOWAS_CONFIG = this.API_BASE_URL + 'EcowasConfigServlet?reportType=insertEcowasConfig';
    this.URL_ADD_PROBE_CONFIG = this.API_BASE_URL + 'EcowasProbe_ConfigServlet?reportType=insertEcowasProbe_ConfigInfo';
    this.URL_ADD_ECOWAS_ORGANIZATION_CONFIG = this.API_BASE_URL + 'Ecowas_organizationServlet?reportType=insertEcowasOrganization';
    this.URL_ADD_ECOWAS_IN_CONFIG = this.API_BASE_URL + 'EcowasInConfigServlet?reportType=insertEcowasInConfigInfo';

    this.URL_ADD_SMSPDP_CONFIG = this.API_BASE_URL + 'SmsdbConfigServlet?reportType=insertSmsdbConfigInfo';
    this.URL_ADD_ECOWAS_SMSPDP_CONFIG = this.API_BASE_URL + 'Ecowas_sms_pdp_configureServlet?reportType=insertEcowasSMSpdpConfigure';
    this.URL_ADD_SMSPDP_LIVE_MAPPING_CONFIG = this.API_BASE_URL + 'EcowasSmsPdp_Live_MappingServlet?reportType=insertEcowasSMSPDPLiveMapping';
    this.URL_ADD_SMSPDP_THRESOLD_CONFIG = this.API_BASE_URL + 'Ecowas_Threshold_ConfServlet?reportType=insertEcowasThresholdConf';
    this.URL_DELETE_RRMS_TABLEDATA = this.API_BASE_URL + 'EcowasConfigSearchServlet?reportType=deleteCountryDetails';
    this.URL_DELETE_SMSPDP_TABLEDATA = this.API_BASE_URL + 'EcowasConfigSearchServlet?reportType=deleteCountryDetails';
    
    this.URL_ADD_RRMS_COUNTRYDATA = this.API_BASE_URL + 'EcowasConfigSearchServlet?reportType=insertCountryDetails';
    this.URL_ADD_SMSPDP_COUNTRYDATA = this.API_BASE_URL + 'EcowasConfigSearchServlet?reportType=insertCountryDetails';


    this.URL_GET_ECOWAS_ALLOWED_GT = this.API_BASE_URL + 'Allowed_GtServlet?reportType=GetAllowed_GtServletInfo'
   this.URL_GET_ECOEAS_CC_NDC = this.API_BASE_URL + 'Ecowas_CC_NDCServlet?reportType=getEcowas_cc_ndcInfo'
    this.URL_GET_ECOWAS_MCC_MNC = this.API_BASE_URL +'EcowasMccMncServlet?reportType=getEcowasMCCMncInfo'
    this.URL_GET_ECOWAS_THRESHOLD_CONFIG = this.API_BASE_URL + 'EcowasInEcowasThresholdConfigServlet?reportType=getEcowasIn_ThresholdConfig'
    this.URL_GET_RRMS_PROBRDB_ALLOWED_GT = this.API_BASE_URL + 'Probedb_AllowedGtServlet?reportType=Probe_Allowed_GtServletInfo'
    this.URL_GET_RRMS_PROBDB_CC_NDC = this.API_BASE_URL + 'Probedb_CcNdcServlet?reportType=getProbe_cc_ndcInfo'
    this.URL_GET_RRMS_PROBDB_MCC_MNC = this.API_BASE_URL + 'Probe_EcowasMccMncServlet?reportType=getProbe_MccMncInfo'
    this.URL_GET_RRMS_PROBDB_ORGANIZATION = this.API_BASE_URL + 'Probedb_organizationServlet?reportType=getProbe_organizationInfo'

    this.URL_UPDATE_ECOWAS_ALLOWED_GT =this.API_BASE_URL +'Allowed_GtServlet?reportType=updateEcowas_Allowed_GtInfo';
    this.URL_UPDATE_ECOEAS_CC_NDC = this.API_BASE_URL + 'Ecowas_CC_NDCServlet?reportType=updateEcowas_cc_ndcInfo';
    this.URL_UPDATE_ECOWAS_MCC_MNC= this.API_BASE_URL + 'EcowasMccMncServlet?reportType=updateEcowasMCCMncInfo';
    this.URL_UPDATE_ECOWAS_THRESHOLD_CONFIG= this.API_BASE_URL + 'EcowasInEcowasThresholdConfigServlet?reportType=updateEcowasIn_ThresholdConfig';
    this.URL_UPDATE_RRMS_PROBRDB_ALLOWED_GT= this.API_BASE_URL + 'Probedb_AllowedGtServlet?reportType=updateProbe_Allowed_GtInfo';
    this.URL_UPDATE_RRMS_PROBDB_CC_NDC= this.API_BASE_URL + 'Probedb_CcNdcServlet?reportType=updateProbe_cc_ndcInfo';
    this.URL_UPDATE_RRMS_PROBDB_MCC_MNC= this.API_BASE_URL + 'Probe_EcowasMccMncServlet?reportType=updateProbe_MccMncInfo';
    this.URL_UPDATE_RRMS_PROBDB_ORGANIZATION= this.API_BASE_URL + 'Probedb_organizationServlet?reportType=updateProbe_organizationInfo';


    this.URL_ADD_ECOWAS_ALLOWED_GT =this.API_BASE_URL +'Allowed_GtServlet?reportType=insertEcowas_Allowed_GtInfo';
    this.URL_ADD_ECOEAS_CC_NDC=this.API_BASE_URL +'Ecowas_CC_NDCServlet?reportType=insertEcowas_cc_ndcInfo';
    this.URL_ADD_ECOWAS_MCC_MNC=this.API_BASE_URL +'EcowasMccMncServlet?reportType=insertEcowasMCCMncInfo';
    this.URL_ADD_ECOWAS_THRESHOLD_CONFIG=this.API_BASE_URL +'EcowasInEcowasThresholdConfigServlet?reportType=insertEcowasIn_ThresholdConfigInfo';
    this.URL_ADD_RRMS_PROBRDB_ALLOWED_GT=this.API_BASE_URL +'Probedb_AllowedGtServlet?reportType=insertProbe_Allowed_GtInfo';
    this.URL_ADD_RRMS_PROBDB_CC_NDC=this.API_BASE_URL +'Probedb_CcNdcServlet?reportType=insertProbe_cc_ndcInfo';
    this.URL_ADD_RRMS_PROBDB_MCC_MNC=this.API_BASE_URL +'Probe_EcowasMccMncServlet?reportType=insertProbe_MccMncInfo';
    this.URL_ADD_RRMS_PROBDB_ORGANIZATION=this.API_BASE_URL +'Probedb_organizationServlet?reportType=insertProbe_organizationInfo';



  this.URL_DELETE_ECOWAS_ALLOWED_GT = this.API_BASE_URL + 'Allowed_GtServlet?reportType=deleteEcowas_Allowed_GtInfo';
  this.URL_DELETE_ECOEAS_CC_NDC = this.API_BASE_URL + 'Ecowas_CC_NDCServlet?reportType=deleteEcowas_cc_ndcInfo';
  this.URL_DELETE_ECOWAS_MCC_MNC = this.API_BASE_URL + 'EcowasMccMncServlet?reportType=deleteEcowasMCCMncInfo';
  this.URL_DELETE_ECOWAS_THRESHOLD_CONFIG = this.API_BASE_URL + 'EcowasInEcowasThresholdConfigServlet?reportType=deleteEcowasIn_ThresholdConfig';
  this.URL_DELETE_RRMS_PROBRDB_ALLOWED_GT = this.API_BASE_URL + 'Probedb_AllowedGtServlet?reportType=deleteProbe_Allowed_GtInfo';
  this.URL_DELETE_RRMS_PROBDB_CC_NDC = this.API_BASE_URL + 'Probedb_CcNdcServlet?reportType=deleteProbe_cc_ndcInfo';
  this.URL_DELETE_RRMS_PROBDB_MCC_MNC = this.API_BASE_URL + 'Probe_EcowasMccMncServlet?reportType=deleteProbe_MccMncInfo';
  this.URL_DELETE_RRMS_PROBDB_ORGANIZATION = this.API_BASE_URL + 'Probedb_organizationServlet?reportType=deleteProbe_organizationInfo';


  this.URL_UPLOAD_RRMS_SERVICE_LIVE_DATA = this.API_BASE_URL + 'UploadServletNew';
  this.URL_GET_UPLOAD_RRMS_SERVICE_LIVE_DATA = this.API_BASE_URL + 'ReadExcelServlet';

  //  this.URL_COUNTRY_FOR_NETWORK_ADDITION = this.API_BASE_URL + 'EcowasBusinessServlet?reportType=getVistingOrgIds';
  this.URL_COUNTRY_FOR_NETWORK_ADDITION = this.API_BASE_URL + 'EcowasBusinessServlet?reportType=getVistingCountries';
  this.URL_GET_NETWORK_ADDITION = this.API_BASE_URL + 'EcowasSmsPdpLiveMappingServlet?reportType=getEcowasSmsPdp_Live_Mapping';
  this.URL_ADD_NETWORK_ADDITION = this.API_BASE_URL + 'EcowasSmsPdpLiveMappingServlet?reportType=insertEcowasSMSPDPLiveMapping';
  this.URL_UPDATE_NETWORK_ADDITION = this.API_BASE_URL + 'EcowasSmsPdpLiveMappingServlet?reportType=updateEcowasSmsPdp_Live_Mapping';
  this.URL_DELETE_NETWORK_ADDITION = this.API_BASE_URL + 'EcowasSmsPdpLiveMappingServlet?reportType=deleteEcowasSmsPdp_Live_Mapping';
  this.URL_GET_NETWORK_FOR_SELECTED_COUNTRY = this.API_BASE_URL + 'EcowasBusinessServlet?reportType=getVistingOrgIds'
  
  
  }
}